<template>
  <v-container fluid class="fill-height d-flex align-center justify-center">
    <div style="text-align:center;">
      <v-progress-circular indeterminate size="48" class="mb-4" />
      <div class="text-h6">Loading your estimate...</div>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "QuoteRedirect",

  mounted() {
    try {
      const fullPath = this.$route.params.pathMatch;

      if (!fullPath) {
        return this.$router.replace("/");
      }

      const parts = fullPath.split("/");
      const code = parts[parts.length - 1];

      if (!code || code.length < 6) {
        throw new Error("Invalid code");
      }

      axios.post(this.serverURL + "/resolve_code", { code }).then(res => {
        const { id } = res.data;

        if (!id) {
          throw new Error("Missing id");
        }

        // 🔥 THIS IS THE KEY PART
        // this.$router.replace(`/aichat/${id}`);
        // this.$router.push({
        //   path: `/aichat/${id}`
        // });
        // window.location.href = `/#/aichat/${id}`;
        const host =
          window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
            ? window.location.origin
            : "https://portal.moverai.com";

        window.location.href = `${host}/#/aichat/${id}`;
      });
    } catch (err) {
      console.error("Quote redirect error:", err);
      this.$router.replace("/not-found");
    }
  }
};
</script>

<style scoped>
.fill-height {
  height: 100vh;
}
</style>
